import React from 'react';
import { AppHeader } from 'src/components/ui';
import { Survey } from './survey';

export const SurveyListPage: React.FC = () => {
  return (
    <AppHeader>
      <Survey />
    </AppHeader>
  );
};
